
    // IMPORTS
    import { computed, defineComponent, onMounted, ref } from 'vue'
    import { buildLocalization } from '@/util'
    import { Input } from '@progress/kendo-vue-inputs'
    import { Button } from '@progress/kendo-vue-buttons'
    import { StringUtil } from '@/util'
    import { ISearchInput } from '@/types/search'
    import { useUserStateStore } from '@/store/userState'

    export default defineComponent({
        name: 'searchInput',

        components: {
            'k-input': Input,
            'k-button': Button
        },

        emits: {
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            'newSearchInput': (value: ISearchInput) => true,
        },

        setup(props, { emit }) {
            /********************************************************************************************************************
             INIT
             ********************************************************************************************************************/
            const userStateStore = useUserStateStore()

            const initialSearchText = userStateStore.sparePartPageState.searchText ?? ''

            /********************************************************************************************************************
             PUBLIC DATA
             ********************************************************************************************************************/
            const internalSearchText = ref(initialSearchText)
            const publicData = { internalSearchText }

            /********************************************************************************************************************
             COMPUTED DATA
             ********************************************************************************************************************/
            const searchAllowed = computed(() => StringUtil.hasContent(internalSearchText.value))
            const computedData = { searchAllowed }

            /********************************************************************************************************************
             PUBLIC METHODS AND EVENT HANDLERS
             ********************************************************************************************************************/
            const { localize } = buildLocalization()

            function onSearch(jumpToFirstResult: boolean) {
                userStateStore.setSparePartSearchText(internalSearchText.value)

                emit('newSearchInput', {
                    searchText: internalSearchText.value,
                    jumpToFirstResult: jumpToFirstResult
                })
            }

            function checkSearchSubmit(e: KeyboardEvent) {
                if (e.key == 'Enter') {
                    onSearch(true)
                }
            }

            function clearSearch() {
                internalSearchText.value = ''
                onSearch(true)
            }

            const publicMethods = { localize, onSearch, checkSearchSubmit, clearSearch }

            /********************************************************************************************************************
             COMPONENT INTERFACE
            ********************************************************************************************************************/
            onMounted(() => {
                if (initialSearchText != '') {
                    onSearch(false)
                }
            })

            /********************************************************************************************************************
             COMPONENT INTERFACE
             ********************************************************************************************************************/
            return { ...publicData, ...computedData, ...publicMethods }
        }
    });
